export default (axios, payload) => axios.put(`/report/template/${payload.id}`, payload);
